import {FC, useMemo} from 'react';

import classNames from 'classnames';

import {config} from 'config/env';
import {Product} from 'types';

import {ProductCard} from '../product-card';
import {CarouselProductCardListContainer} from './styles';
import {CarouselProductCardListProps} from './types';
import {ProductCardV2} from '../product-card-v2';

export const CarouselProductCardList: FC<CarouselProductCardListProps> = ({
  productsData,
  carouselAnalytics,
  sendCarouselImpressionAnalytics,
  isSearchBoxCarousel
}) => {
  const isProductCardV2Enabled = config.RECOM_SHOPPING_ENABLE_PRODUCT_CARD_V2;
  return (
    <>
      {useMemo(() => {
        return productsData?.map((item, idx) => (
          <CarouselProductCardListContainer
            key={idx}
            className={classNames({
              isSearchBoxCarousel: isSearchBoxCarousel
            })}
          >
            {isProductCardV2Enabled ? (
              <ProductCardV2
                key={idx}
                itemIndex={idx}
                product={item as Product}
                carouselAnalyticsProps={carouselAnalytics}
                sendCarouselImpressionAnalytics={sendCarouselImpressionAnalytics}
                isSearchBoxCarousel={isSearchBoxCarousel}
                carouselIndex={0}
              />
            ) : (
              <ProductCard
                key={idx}
                itemIndex={idx}
                product={item as Product}
                carouselAnalyticsProps={carouselAnalytics}
                sendCarouselImpressionAnalytics={sendCarouselImpressionAnalytics}
                isSearchBoxCarousel={isSearchBoxCarousel}
                carouselIndex={0}
              />
            )}
          </CarouselProductCardListContainer>
        ));
      }, [
        productsData,
        carouselAnalytics,
        isSearchBoxCarousel,
        sendCarouselImpressionAnalytics,
        isProductCardV2Enabled
      ])}
    </>
  );
};
